import React, { useState, useEffect, useContext } from 'react';
import cn from "classnames";
import stylesCommon from "../../common.module.scss"
import CustomLists from '../../../custom/custom-lists/CustomLists';
import CustomButton from '../../../custom/custom-button/CustomButton';
import { User } from '../../../../services';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../../context/auth.context';
import { toast } from 'react-toastify';
import axios from 'axios';
import { configData } from '../../../../services/api-config';
import { useTranslation } from 'react-i18next'; // Import useTranslation

export const USER_ROLE = {
  isSupervisor: "head",
  isEmployee: "employee",
}

const SurveyUserRegistrationThird = ({ updateStep, setData, data, code}) => {
  const { t } = useTranslation(); // Initialize useTranslation
  const [callNextStep, setCallNextStep] = useState(false);
  const [isCheck, setIsCheck] = useState(data.isHead !== undefined ? data.isHead : false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const auth = useContext(AuthContext);

  // Use t() for item text
  const items = [
    {
      text: t('registrationSurveyUserThird.role.manager'),
      summary: "",
      value: USER_ROLE.isSupervisor,
    },
    {
      text: t('registrationSurveyUserThird.role.employee'),
      summary: "",
      value: USER_ROLE.isEmployee,
    },
  ];

  const activeChoiceIndex = data?.isHead ? 0 : (data?.role === USER_ROLE.isEmployee ? 1 : null);

  const handleUserRoleChange = (selectedIndex) => {
    const selectedValue = items[selectedIndex].value;
    setData({ ...data, isHead: selectedValue === USER_ROLE.isSupervisor });
    setIsCheck(true);
  };

  useEffect(() => {
    if (callNextStep) {
      nextStep();
      setCallNextStep(false);
    }
  }, [callNextStep]);

  const handleLogin = async () => {
    const payload = {
      username: data.email ? data.email.toLowerCase() : data.email,
      password: data.password,
    };

    if (payload.username && payload.password) {
      try {
        const response = await axios.get(configData.BASE_URL + 'api/v1/users/login', {
          auth: payload,
          withCredentials: true
        });

        if (response.status === 200) {
          response.data.isAuthenticated = true;
          auth.login(response.data.accessToken);
          if (data.type === "expeditor") {
            navigate("/onboarding-expeditor");
          } else navigate("/onboarding");
        }
      } catch (error) {
        // TODO: Consider adding a specific translation key for this error
        toast.error(t('registrationSurveyUserThird.toast.loginError') + ": " + error.message);
      } finally {
      }
    } else {
      toast.error(t('registrationSurveyUserThird.toast.loginError')); // Use translation
    }
  };

  const nextStep = async () => {
    if (isCheck) {
      setIsLoading(true);
      try {
        const { isChecked, ...newData } = data;
        if (data.clientId && code) {
          await User.registerInvitationExpeditor(data.clientId, code, newData);
        } else {
          await User.registerNew(newData);
        }
        toast.success(t('registrationSurveyUserThird.toast.registrationSuccess')); // Use translation
        await handleLogin();
      } catch (error) {
        console.error("Ошибка при регистрации нового пользователя:", error); // Keep console error in English
        toast.error(t('registrationSurveyUserThird.toast.registrationError')); // Use translation
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div className={stylesCommon.fullWidth}>
      <CustomLists
        items={items}
        isRadioBtn={true}
        onSelectionChange={handleUserRoleChange}
        activeChoice={activeChoiceIndex} />
      <div className={stylesCommon.mrXmedium}>
        <CustomButton isFall isLoading={isLoading} isDisabled={!isCheck} text={t('registrationSurveyUserThird.button.login')} onClick={nextStep} />
      </div>
    </div>
  );
};

export default SurveyUserRegistrationThird;
